<script setup lang="ts">
/**
 * Small inline loading animation shown by the itemV3Stones*.vue parameter components
 * while their variants haven't been loaded yet (i.e. while the "active"/matching
 * variant computed is still falsy). Mirrors the color/animation language of the
 * loading overlay in itemV3ParameterBox.vue, just scaled down for inline use.
 */
</script>

<template>
  <div class="w-full flex items-center justify-center gap-3 py-6">
    <span class="relative flex size-8 items-center justify-center">
      <span
          class="absolute size-full rounded-full bg-radial-[at_35%_30%] from-[#a57a43] to-[#805b2f] opacity-25 animate-ping"
      ></span>
      <span
          class="absolute size-6 rounded-full border-[3px] border-[#e7ddcc] border-t-[#8b6536] animate-spin"
      ></span>
      <span
          class="size-2 rounded-full bg-radial-[at_35%_30%] from-[#a57a43] to-[#805b2f] animate-pulse"
      ></span>
    </span>
  </div>
</template>

<style scoped>
</style>
